export default __webpack_public_path__ + "static/media/Group6.e1326049.svg";